import { useNavigate } from "react-router-dom";
import Page from "src/layouts/Page";
import RoleForm from "../../components/RoleForm/RoleForm";
import useCreateRole from "../../hooks/useCreateRole";
import useAvailablePermissions from "../../hooks/useAvailablePermissions";

const EMPTY_DEFAULTS: RoleFormValues = {
	name: "",
	permissions: []
};

const CreateRole = () => {
	const navigate = useNavigate();
	const { mutate: createRole, isLoading } = useCreateRole();
	const { data: availablePermissions } = useAvailablePermissions();

	const handleSubmit = (data: RoleFormValues) => {
		createRole(
			{ name: data.name, permissions: data.permissions },
			{
				onSuccess: () => navigate("/users/permissions")
			}
		);
	};

	return (
		<Page>
			<RoleForm
				defaultValues={EMPTY_DEFAULTS}
				availablePermissions={availablePermissions ?? []}
				onSubmit={handleSubmit}
				isSubmitting={isLoading}
				isEdit={false}
				backPath="/users/permissions"
			/>
		</Page>
	);
};

export default CreateRole;
